const isDateValue = (val) => val && typeof val === 'string' && !isNaN(new Date(val).getTime());

export const getShiftStatus = (shift, defaultColor = '#B7966A') => {
  if (!shift) {
    return { statusText: 'Scheduled', statusColor: defaultColor, statusTextColor: 'white' };
  }

  const shiftStatus = shift[366] && shift[366].value ? shift[366].value : '';
  const clockedIn = shift[425] && isDateValue(shift[425].value);
  const shiftStart = shift[6] && shift[6].value ? new Date(shift[6].value) : null;

  if (shiftStatus === 'No Show') {
    return { statusText: 'No Show', statusColor: 'crimson', statusTextColor: 'white' };
  }
  if (clockedIn || shiftStatus === 'Manual Data Needed' || shiftStatus === 'Completed - See Notes' || shiftStatus === 'Completed - Problems' || shiftStatus === 'Confirmed') {
    const shiftEnd = shift[7] && shift[7].value ? new Date(shift[7].value) : null;
    if (shiftEnd && new Date() > shiftEnd) {
      return { statusText: 'Complete', statusColor: 'limegreen', statusTextColor: 'black' };
    }
    return { statusText: 'Clocked In', statusColor: 'limegreen', statusTextColor: 'black' };
  }
  if (shiftStart && new Date() > shiftStart) {
    return { statusText: 'Late', statusColor: 'orange', statusTextColor: 'white' };
  }
  return { statusText: 'Scheduled', statusColor: defaultColor, statusTextColor: 'white' };
};
